import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

interface MenuDetails {
  applicationCode: string;
  menuKey: string;
  userId: number;
  userDisplayName: string;
}

@Component({
  selector: 'app-user-menu-preview-dialog',
  templateUrl: './user-menu-preview-dialog.component.html',
  styleUrls: ['./user-menu-preview-dialog.component.scss']
})

export class UserMenuPreviewDialogComponent implements OnInit {
  public menuData;

  constructor(
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: MenuDetails,
  ) { }

  ngOnInit(): void {
    this.getMenu();
  }

  async getMenu(): Promise<void> {
    await this.baseService.executeCommand<any>(`portal_user_management_user_menu_preview`, { applicationCode: this.data.applicationCode, menuKey: this.data.menuKey, userId: this.data.userId }).subscribe(result => {
      if (result.responseCode === 0) {
        this.menuData = result.data;
      }
    });
  }

}
